import { AnnotationToolType } from '../../__legacy__/modules/annotation/submodules/annotationTypes/models/annotationToolType';
import { ImageSetType } from '../../__legacy__/modules/projectDetails/sub/images/projectDetailsImages.model';
import { IChartPoint, ITrainingMatrix } from './jobMetrics.model';

interface IPredictedPoint extends IChartPoint {
  score: number;
}

interface IPredictedVertice {
  lat: number;
  lng: number;
}

interface IPredictedRectangle {
  score: number;
  vertices: IPredictedVertice[];
}

export enum GROUND_TRUTH {
  BAD = 'Bad',
  GOOD = 'Good',
}

export interface IGroundTruth {
  className: string | null;
  predictionCounts: Record<string, number> | null;
}

interface IGeometricPredictionBase {
  classId: string;
  className: string;
  selectorType: AnnotationToolType;
  color?: string;
}

export interface IPointPrediction extends IGeometricPredictionBase {
  points: IPredictedPoint[];
}

export interface IRectanglePrediction extends IGeometricPredictionBase {
  rectangles: IPredictedRectangle[];
}

export interface IPredictionImage {
  id: string;
  name: string;
  imageSetType?: ImageSetType;
  url: string;
  heatmapUrl: string | null;
  maskUrl: string | null;
  predictedPoints: IPointPrediction[] | null;
  predictedRectangles: IRectanglePrediction[] | null;
  prediction: {
    confusionMatrix: ITrainingMatrix | null;
    recall: number | null;
    precision: number | null;
    f1: number | null;
    auc: number | null;
    count: number | null;
    precisionRecallCurve: IChartPoint[] | null;
    score: number | null;
    groundTruth: IGroundTruth | null | undefined;
    prediction: string | null;
    averageEntropy: number | null;
    confidence: number | null;
  };
}
